import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Tab,
  Nav,
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import { useScreenSize, useCustomScreen } from "../Utils";
import { Link } from "react-router-dom";

export default function ReportsSection() {
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const [index, setIndex] = useState(1);

  const devicePixelRation = window.devicePixelRatio; 

  const [showModal, setShowModal] = useState(false);
    const [isAustraliaSample, setIsAustraliaSample] = useState(false);

  const handleOpen = () => {
    setShowModal(!showModal);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const reportData = [
    {
      tabType: "BASIC Report",
      title: "BASIC Report",
      description: "Get square footage for rough estimates and simple roofs:",
      features: [
        "Simple 1-page report",
        "Square footage & squares",
        "Pitch identification",
        "Wire diagram",
        "Clear aerial photo of the roof",
        "Can be upgraded to other reports ",
      ],
      buttonText: "Order Basic Report",
      imageSrc: "/images/Basic_Sample_page.jpg",
      sampleReport: [
        "/images/Basic_Sample_page.jpg"
      ],
      sampleReportAU: [
        "/images/Metric_Basic_pages-to-jpg-0001.jpg"
      ],
    },
    {
      tabType: "STANDARD Report",
      title: "STANDARD Report",
      description:
        "Get all the measurements you need to estimate your project.",
      features: [
        "Practical 1-page report",
        "Measurement summary",
        "Wire diagram with measurements",
        "Pitch by roof facet",
        "Clear aerial photo of the roof",
        "Can be upgraded to Comprehensive report",
      ],
      buttonText: "Order Standard Report",
      imageSrc:  "/images/Standard_Sample_page.jpg",
      sampleReport: [
        "/images/Standard_Sample_page.jpg",
      ],
       sampleReportAU: [
        "/images/Metric_Standard_page-0001.jpg"
      ],
    },
    {
      tabType: "COMPREHENSIVE Report",
      title: "COMPREHENSIVE Report",
      description: "Elevate your presentation with detail and clarity.",
      features: [
        "Professional 6-page report",
        "Individual pages for measurements, pitches, and facet areas",
        "Includes drip edge and flashing measurements",
        "Waste calculations",
        "Blank wire diagram for notes",
      ],
      buttonText: "Order Comprehensive Report",
      imageSrc: "/images/comprehensiveThumbnail_1.jpeg",
      subImgSrc: "/images/comprehensiveSample_page-02.jpg",
      sampleReport: [
        "/images/comprehensiveSample_page-01.jpg",
        "/images/comprehensiveSample_page-02.jpg",
        "/images/comprehensiveSample_page-03.jpg",
        "/images/comprehensiveSample_page-04.jpg",
        "/images/comprehensiveSample_page-05.jpg",
        "/images/comprehensiveSample_page-06.jpg",
      ],
       sampleReportAU: [
        "/images/Metric_Comprehension_page-0001.jpg",
         "/images/Metric_Comprehension_page-0002.jpg",
          "/images/Metric_Comprehension_page-0003.jpg", 
          "/images/Metric_Comprehension_page-0004.jpg",
          "/images/Metric_Comprehension_page-0005.jpg",
          "/images/Metric_Comprehension_page-0006.jpg",

      ],
    },
    {
      tabType: "CLAIMS Report",
      title: "CLAIMS Report",
      description:
        "Import an .ESX and transfer to your claim file in Xactimate.",
      features: [
        ".ESX sketch (Xactimate)",
        ".PDF supplemental for quick reference:",
      ],
      subFeatures: [
        "Measurement summary",
        "Large aerial photo",
        "Sketch image",
      ],
      buttonText: "Order Claims Report",
      imageSrc:   "/images/Claims_Sample_page.jpg",
      sampleReport: [
        "/images/Claims_Sample_page.jpg",
      ],
    },
  ];

  const [reportFile, setReportFile] = useState(reportData[1].sampleReport);
  const [reportFileAU, setReportFileAU] = useState(reportData[1].sampleReportAU);

  useEffect(() => {
    reportData.forEach((report) => {
      report.sampleReport.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
       report.sampleReportAU?.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    });
  }, []);


  
  return (
    <div
      style={{
        backgroundImage: "url('/images/Picture5.png')",
        position: "relative",
        height: isSmallScreen ? "100%" : "100vh",
      }}
    >
      <section
        style={{
          height: isSmallScreen ? "auto" : "100vh",
          backgroundColor: "#4e585ae6",
        }}
        className="py-5 p-3 d-flex flex-column xs-h-[full] justify-content-center align-items-center"
      >
        <Container fluid>
          <header
            className="text-center "
            style={{
              marginBottom: is4kScreen
                ? "3rem"
                : isXxlScreen
                ? "1.8rem"
                : isXlScreen
                ? "1.6rem"
                : isLargeScreen
                ? "1.2rem"
                : "",
            }}
          >
            <h1
              className="text-white"
              style={{
                fontWeight: "bold",
                fontSize: is4kScreen
                  ? "5.3rem"
                  : isXxlScreen
                  ? "2.8rem"
                  : isXlScreen
                  ? "2.6rem"
                  : isIpadProPortrait
                  ? "3rem"
                  : isLargeScreen
                  ? "2.5rem"
                  : isMediumScreen
                  ? "2.4rem"
                  : "2rem",
                paddingTop:
                  isXxlScreen && devicePixelRation === 1.25
                    ? "2rem"
                    : isXlScreen
                    ? "1.3rem"
                    : "",
                paddingBottom: is4kScreen
                  ? "2.5rem"
                  : isMediumScreen
                  ? "2.5rem"
                  : isXxlScreen
                  ? "2rem"
                  : isIpadProPortrait
                  ? "3rem"
                  : "",
              }}
            >
              We have the right report for you{" "}
            </h1>
          </header>

          {/* Tab Navigation */}
          <Tab.Container
            activeKey={index}
            // defaultActiveKey="first"
            onSelect={(k) => {
              setIndex(k);
            }}
            className="custom-tabs"
          >
            <Row
              style={{
                marginLeft: isSmallScreen ? "0.5em" : ".3em",
              }}
              className="w-100 flex justify-content-center align-items-center"
            >
              <Nav
                variant="pills"
                className="mb-4 w-100 d-flex justify-content-center align-items-center"
              >
                <Row className="w-100 ">
                  {reportData.map((report, idx) => (
                    <Col
                      xs={4}
                      md={6}
                      lg={3}
                      key={idx}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <Nav.Item
                        className="w-100"
                        style={{ marginBottom: isSmallScreen ? "10px" : "" }}
                        onClick={() => {
                          setReportFile(report.sampleReport);
                          report.sampleReport.forEach((src) => {
                            const img = new Image();
                            img.src = src;
                          });
                        }}
                      >
                        <Nav.Link
                          eventKey={idx}
                          className={`text-center bg-white text-black py-3 w-100 mt-sm-3 ${
                            isIpadProPortrait
                              ? "d-flex justify-content-center align-items-center"
                              : ""
                          }`}
                          style={{
                            borderRadius: "5px",
                            fontSize: is4kScreen
                              ? "2.5rem"
                              : isXxlScreen
                              ? "1.2rem"
                              : isXlScreen
                              ? "1.2rem"
                              : isIpadProPortrait
                              ? "1.7rem"
                              : isLargeScreen
                              ? "1rem"
                              : isMediumScreen
                              ? "1.3rem"
                              : "",
                            height: isIpadProPortrait ? "6rem" : "",
                            fontWeight: "bold",
                          }}
                        >
                          {report.title}
                        </Nav.Link>
                      </Nav.Item>
                    </Col>
                  ))}
                </Row>
              </Nav>
            </Row>

            <Tab.Content>
              {reportData.map((report, idx) => (
                <>
                  <Tab.Pane eventKey={idx} key={idx}>
                    <Row className="align-items-center mt-md-2 mt-0 p-0 p-md-4">
                      <Col xs={12} md={6} className="text-center text-md-start">
                        <h2
                          className="text-white"
                          style={{
                            fontSize: is4kScreen
                              ? "5.2rem"
                              : isXxlScreen
                              ? "2.8rem"
                              : isXlScreen
                              ? "2.8rem"
                              : isIpadProPortrait
                              ? "3rem"
                              : isLargeScreen
                              ? "2.4rem"
                              : isMediumScreen
                              ? "2.2rem"
                              : "",
                            fontWeight: "bold",
                          }}
                        >
                          {report.title}
                        </h2>
                        <h5
                          className="text-white"
                          style={{
                            fontSize: is4kScreen
                              ? "3rem"
                              : isXxlScreen
                              ? "1.3rem"
                              : isXlScreen
                              ? "1.3rem"
                              : isIpadProPortrait
                              ? " 1.8rem"
                              : isLargeScreen
                              ? "1.2rem"
                              : isMediumScreen
                              ? "1.2rem"
                              : "",
                          }}
                        >
                          {report.description}
                        </h5>
                        <ul className="text-white">
                          {report.features.map((feature, index) => (
                            <>
                              <li
                                key={index}
                                style={{
                                  fontSize: is4kScreen
                                    ? "2.6rem"
                                    : isXxlScreen
                                    ? "1.1rem"
                                    : isXlScreen
                                    ? "1.2rem"
                                    : isIpadProPortrait
                                    ? "1.8rem"
                                    : isLargeScreen
                                    ? "1.2rem"
                                    : isMediumScreen
                                    ? "1.2rem"
                                    : "",
                                }}
                              >
                                <i className="bi bi-caret-right-fill text-white"></i>{" "}
                                {feature}
                              </li>
                            </>
                          ))}
                          <ul>
                            {report.subFeatures &&
                              report.subFeatures.map((subFeature) => (
                                <li
                                  style={{
                                    fontSize: is4kScreen
                                      ? "2.6rem"
                                      : isXxlScreen
                                      ? "1.1rem"
                                      : isXlScreen
                                      ? "1.2rem"
                                      : isIpadProPortrait
                                      ? "1.8rem"
                                      : isLargeScreen
                                      ? "1rem"
                                      : isMediumScreen
                                      ? "1.2rem"
                                      : "",
                                  }}
                                >
                                  {subFeature}
                                </li>
                              ))}
                          </ul>
                        </ul>
                        <Link to="/order-page">
                          {" "}
                          <Button
                            className="login-btns btn"
                            style={{
                              fontSize: is4kScreen
                                ? "2.6rem"
                                : isXxlScreen
                                ? "1.2rem"
                                : isXlScreen
                                ? "1.2rem"
                                : isIpadProPortrait
                                ? "1.8rem"
                                : isLargeScreen
                                ? "1.2rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : "",
                            }}
                          >
                            {report.buttonText}
                          </Button>
                        </Link>
                      </Col>

                      <Col xs={12} md={6} className="text-center">
                        <img
                          src={report.imageSrc}
                          alt={report.title}
                          style={{
                            width: is4kScreen
                              ? "65%"
                              : isIpadProPortrait
                              ? "100%"
                              : isLargeScreen
                              ? "50%"
                              : isMediumScreen
                              ? "80%"
                              : "45%",
                          }}
                        />
                        {/* {report.title === "COMPREHENSIVE Report" && (
                          <img
                            src={report.imageSrc}
                            alt={report.title}
                            // className="img-fluid"
                            className="z-3 position-absolute"
                            style={{
                              width: is4kScreen
                                ? "65%"
                                : isLargeScreen
                                ? "50%"
                                : "45%",
                            }}
                          />
                        )} */}
                        <div style={{display: "flex", justifyContent: "center", gap: "30px"}}>
                        <h4
                          onClick={() => {setIsAustraliaSample(false); 
                          setReportFile(report.sampleReport); handleOpen()}}
                          style={{
                            paddingTop: is4kScreen
                              ? "1rem"
                              : isXlScreen
                              ? "0.5rem"
                              : "1rem",
                          }}
                        >
                          <a
                            style={{
                              fontSize: is4kScreen
                                ? "2.5rem"
                                : isXxlScreen
                                ? "1.3rem"
                                : isXlScreen
                                ? "1rem"
                                : isIpadProPortrait
                                ? "1.6rem"
                                : isLargeScreen
                                ? ""
                                : "",

                              color: "lightblue",
                            }}
                            href="javascript:void(0)"
                          >
                           See US/Canada Example
                          </a>
                        </h4>
                        
                       {report.sampleReportAU && (
  <h4
    onClick={() => {
      setIsAustraliaSample(true);
      setReportFileAU(report.sampleReportAU);
      handleOpen();
    }}
    style={{
      paddingTop: is4kScreen
        ? "1rem"
        : isXlScreen
        ? "0.5rem"
        : "1rem",
    }}
  >
    <a
      href="javascript:void(0)"
      style={{
        fontSize: is4kScreen
          ? "2.5rem"
          : isXxlScreen
          ? "1.3rem"
          : isXlScreen
          ? "1rem"
          : isIpadProPortrait
          ? "1.6rem"
          : "",
        color: "lightblue",
      }}
    >
      See Australia Example
    </a>
  </h4>
)}

                        </div>
                      </Col>
                     
                      </Row>
                     
                 
                    
                  </Tab.Pane>
                  
                  <Modal
                    show={showModal}
                    onHide={handleClose}
                    onClick={(e) => e.stopPropagation()}
                    centered
                    scrollable
                    backdrop="static"
                  >
                    <ModalHeader
                      closeButton
                      style={{ background: "lightblue" }}
                    >
                      <ModalTitle>Full Sample</ModalTitle>
                    </ModalHeader>
                    <ModalBody
                      style={{ height: "80vh" }}
                      className="hide-scrollbar embed-responsive"
                    >
                      {(isAustraliaSample ? reportFileAU : reportFile)?.map((file, ind) => ( 
                        <img
                          key={ind + 1}
                          src={file}
                          loading="lazy"
                          style={{
                            width: "100%",
                            height: "100%",
                            marginTop: "0.5rem",
                            objectFit: "contain",
                            border: "1px solid #000",
                          }}
                        />
                      ))}
                    </ModalBody>
                  </Modal>
                </>
              ))}
            </Tab.Content>
          </Tab.Container> 
        </Container>
      </section>
    </div>
  );
}
